<template>
  <div class="channelRecord">
    <PageNav :slider="slider" :openMenu="openMenu">
      <el-main>
        <div id="page-custoMersmanage">
          <div class="head-tab--nav">
            <div class="head-nav h-3 clearFloat">
              <span class="c-normal">电销名单跟进</span>
              <div class="pull-right"></div>
            </div>
          </div>
          <div class="custoMersmanage-container">
            <div class="content" style="padding-top: 0">
              <div class="content-nav--head text-1 Tab-nav-head">
                <div class="c-n--head_lf">
                  <ul class="filter-condition">
                    <li
                      v-for="(item, index) in filtersOption"
                      :key="index"
                      :class="{ 'link-active': index == currentIndex }"
                      @click="addClass(index)"
                    >
                      {{ item }}
                    </li>
                  </ul>
                </div>
              </div>
              <div v-if="!buttonHide" class="flex-wrap pl20 pr20 mt12">
                <div class="flex-al mb10 mr10">
                  <span class="mr10 fs14 color-666">创建时间：</span>
                  <div class="time-box">
                    <el-date-picker
                      v-model="selectForm.range_time"
                      type="daterange"
                      style="width: 260px"
                      :range-separator="$t('Common.to')"
                      value-format="yyyy-MM-dd"
                      :start-placeholder="$t('Common.startTime')"
                      :end-placeholder="$t('Common.endTime')"
                      @change="handleSelect()"
                    ></el-date-picker>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <span class="mr10 fs14 color-666">最后跟踪时间：</span>
                  <div class="time-box">
                    <el-date-picker
                      v-model="selectForm.last_time"
                      type="daterange"
                      style="width: 260px"
                      :range-separator="$t('Common.to')"
                      value-format="yyyy-MM-dd"
                      :start-placeholder="$t('Common.startTime')"
                      :end-placeholder="$t('Common.endTime')"
                      @change="handleSelect()"
                    ></el-date-picker>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <span class="mr10 fs14 color-666">{{
                    $t("Customersmanage.ac")
                  }}</span>
                  <div class="rate-box flex-al">
                    <el-rate
                      v-model="client_levelvalue"
                      @change="handleSelectLevel()"
                      class="client-level-rate level-rate-fliter"
                      :icon-classes="['crm-likes', 'crm-likes', 'crm-likes']"
                      void-icon-class="crm-like"
                      :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
                    ></el-rate>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box">
                    <el-select
                      filterable
                      v-model="selectForm.client_tracestatus"
                      class="select-mini"
                      style="width: 150px"
                      clearable
                      :placeholder="$t('Customersmanage.ae')"
                      @change="handleSelect()"
                    >
                      <el-option
                        v-for="item in clientOptionList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.ishaveinvite"
                      class="select-mini"
                      style="width: 150px"
                      @change="handleSelect()"
                      placeholder="请选择是否柜询"
                    >
                      <el-option label="未柜询" value="0"></el-option>
                      <el-option label="柜询待确认" value="1"></el-option>
                      <el-option label="已柜询" value="2"></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.ishaveaudition"
                      class="select-mini"
                      style="width: 150px"
                      @change="handleSelect()"
                      placeholder="请选择是否试听"
                    >
                      <el-option label="未试听" value="0"></el-option>
                      <el-option label="试听未确认" value="1"></el-option>
                      <el-option label="已试听" value="2"></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.activity"
                      class="select-mini"
                      style="width: 150px"
                      @change="handleSelect()"
                      placeholder="请选择活动"
                    >
                      <el-option
                        v-for="item in ActivityOption"
                        :key="item.activity_id"
                        :label="item.activity_name"
                        :value="item.activity_id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10" v-if="postbe_crmlevel != '2'">
                  <div class="select-box">
                    <el-select
                      filterable
                      v-model="selectForm.tmk_marketer_id"
                      class="select-mini"
                      style="width: 150px"
                      clearable
                      placeholder="请选择筛选人"
                      @change="handleSelect()"
                    >
                      <el-option
                        v-for="item in markerList"
                        :key="item.marketer_id"
                        :label="item.marketer_name"
                        :value="item.marketer_id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>

                <div class="flex-al mb10 mr10">
                  <div class="select-box">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.frommedia_name"
                      class="select-mini"
                      style="width: 150px"
                      @change="frommediaSearch"
                      placeholder="请选择渠道类型"
                    >
                      <el-option
                        v-for="item in SchoolsourceOption"
                        :key="item.frommedia_id"
                        :label="item.frommedia_name"
                        :value="item.frommedia_name"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.channel_id"
                      class="select-mini"
                      style="width: 150px"
                      @change="handleSelect()"
                      placeholder="请选择渠道明细"
                    >
                      <el-option
                        v-for="item in ChannelOption"
                        :key="item.channel_id"
                        :label="item.channel_name"
                        :value="item.channel_id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>

                <div class="flex-al mb10 mr10">
                  <div class="select-box">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.client_answerphone"
                      class="select-mini"
                      style="width: 150px"
                      @change="handleSelect()"
                      :placeholder="$t('Customersmanage.cbj')"
                    >
                      <el-option
                        v-for="(item, index) in clientAnswerphoneList"
                        :key="index"
                        :label="item.client_answerphone_name"
                        :value="item.client_answerphone"
                      ></el-option>
                    </el-select>
                  </div>
                </div>

                <div class="flex-al mb10 mr10" v-if="currentIndex == 0">
                  <div class="select-box">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.nohavetrack"
                      class="select-mini"
                      style="width: 200px"
                      @change="handleSelect()"
                      placeholder="是否七日内未跟踪名单"
                    >
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </div>
                </div>

                <div class="flex-al Inquire-box mb10">
                  <div class="ipt-box">
                    <el-input
                      clearable
                      :style="{
                        width: currentIndex === 0 ? '460px' : '250px',
                      }"
                      :placeholder="
                        currentIndex === 0
                          ? '可检索姓名、主要联系人、主要联系手机、标签名称、意向课程信息'
                          : '可检索姓名、主要联系手机'
                      "
                      class="input-cont"
                      v-model="selectForm.keyword"
                      @change="handleSelectKeyword()"
                    ></el-input>
                  </div>
                  <el-button
                    type="primary"
                    class="btn-inquire"
                    style="margin-right: 0px"
                    @click="handleSelectKeyword()"
                    >{{ $t("Customersmanage.an") }}</el-button
                  >
                </div>
              </div>
              <div v-else-if="buttonHide" class="flex-wrap pl20 pr20 mt12">
                <div class="flex-al mb10 mr10">
                  <el-button type="warning" @click="onTurnAllList"
                    >批量转有效名单</el-button
                  >
                  <el-button type="primary" @click="maoListVisible = true"
                    >批量转毛名单</el-button
                  >
                </div>
              </div>
              <div class="pl20 pr20">
                <div
                  class="table-list"
                  style="position: relative"
                  ref="auto_height_table"
                >
                  <TableList
                    :list="tableData"
                    :options="optionscaozuo"
                    :columns="columns"
                    :operates="operates"
                    :issetting="false"
                    :isSort="false"
                    :tableOperate="tableOperate"
                    :tableSort="tableSort"
                    @handleCommandSort="handleCommandSort"
                    @toggleEditableColumn="toggleEditableColumn"
                    @handleSelectionChange="handleSelectionChange"
                    @handleColumnChange="handleColumnChange"
                    :isCall="true"
                    @emitCallPhone="emitCallPhone"
                  ></TableList>
                  <div class="personalInfo-tips">
                    <i class="crmIcon-ysbh"></i>
                    <span>{{ $t("Common.personalInfo_tips") }}</span>
                  </div>
                </div>
                <el-pagination
                  style="margin-top: 20px"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[10, 20, 30, 40]"
                  :page-size="pagesize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="dataNumber"
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </el-main>
    </PageNav>
    <!-- 侧边栏查看-->
    <SliderBox
      :showSliderBox="showSliderBoxSee"
      class="user-seeing-slider"
      @hideSliderBox="hideSliderSeeBox"
      :sliderWidth="sliderWidth"
    >
      <userSeeing
        :isdisabled="isDisabled"
        :showUserSliderBox="showSliderBoxSee"
        :createJG="createJG"
        :customerId="customerId"
        :ClassMessage="ClassMessage"
        :isTrack="isTrack"
        :isRoot="isRoot"
        :iscanEdit="iscanEdit && currentIndex === 0"
        :seeSliderTitle="seeSliderTitle"
        @hideUserSliderBox="hideSliderSeeBox"
        @studentBinding="studentBinding"
        @handleSliderClick="handleSliderClick"
        @Clickedit="Clickedit"
        @leaning="leaning"
        @onFllowSubmit="onFllowSubmit"
        @ClickFloow="ClickFloow"
        @ClickAudition="ClickAudition"
        @ClickAuditiontime="ClickAuditiontime"
        @emitShowImg="emitShowImg"
        @handleSelectChange="handleSelectChange"
        @updateList="updateList"
        :showCallPhone="true"
        @emitCallPhone="emitCallPhone"
      ></userSeeing>
    </SliderBox>
    <!-- 侧边栏编辑-->
    <SliderBox
      :showSliderBox="showSliderBoxEdit"
      @hideSliderBox="hideSliderBoxEdit"
      :sliderWidth="sliderWidth"
    >
      <userCreate
        :showUserSliderBox="showSliderBoxEdit"
        :Userlist="Userlistedit"
        @hideUserSliderBox="hideSliderBoxEdit"
        :clientOption="clientOption"
        :SchoolsourceOption="SchoolsourceOption"
        :chiefPerson="chiefPerson"
        :SchoolCourseOption="SchoolCourseOption"
        :isrepeat="isrepeat"
        :isEdit="isEdit"
        :FamilyRelation="FamilyRelation"
        :UserInformation="UserInformation"
        :repeatList="repeatList"
        @onSubmit="oneditSubmit"
        @checkIntentionClientData="checkIntentionClientData"
        @deleteFamily="deleteFamily"
        @deleteCourse="deleteCourse"
        @wantToTrack="wantToTrack"
      ></userCreate>
    </SliderBox>
    <!-- 绑定学员 -->
    <el-dialog
      :title="$t('Customersmanage.aq')"
      :visible.sync="createJG"
      class="tan-binding"
      width="30%"
      :before-close="handleClose"
    >
      <div class="create">
        <el-form
          label-width="120px"
          ref="BindstudentFrom"
          :model="BindstudentFrom"
        >
          <el-form-item
            :label="$t('Customersmanage.ar')"
            prop="name"
            :rules="[{ required: true, message: '请选择学员' }]"
          >
            <el-select
              filterable
              v-model="BindstudentFrom.name"
              remote
              :remote-method="remoteMethod"
              :loading="loading"
              style="width: 200px"
              :placeholder="$t('Customersmanage.as')"
            >
              <el-option
                v-for="item in FriendName"
                :key="item.client_id"
                :value="item.client_id"
                :label="item.client_cnname"
              >
                {{ item.client_cnname }}
                <i slot="suffix" class="el-input__icon el-icon-date"></i>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('Customersmanage.at')"
            prop="relation"
            :rules="[{ required: true, message: '请选择绑定关系' }]"
          >
            <el-select
              filterable
              v-model="BindstudentFrom.relation"
              style="width: 200px"
              :placeholder="$t('Customersmanage.au')"
            >
              <el-option
                v-for="item in FriendRelation"
                :key="item.friendrelation_id"
                :value="item.friendrelation_name"
                :label="item.friendrelation_name"
                >{{ item.friendrelation_name }}</el-option
              >
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onBindSubmit()">{{
          $t("Customersmanage.av")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 跟班试听 中间-->
    <auditClass
      :leaningVisible="leaningVisible"
      :auditionGenre="auditionGenre"
      :Auditiontime="Auditiontime"
      @handClickcompare="handClickcompare"
      @handClickcancel="handClickcancel"
      @handleClose="handleCloseLean"
    ></auditClass>
    <!-- 编辑列 -->
    <el-dialog
      :title="$t('Customersmanage.aw')"
      class="setting-column"
      :visible.sync="settingVisible"
      width="450px"
      :before-close="handleClose"
    >
      <el-transfer
        :titles="[$t('Customersmanage.ax'), $t('Customersmanage.ay')]"
        v-model="oprateColumn"
        @change="Changeoprate()"
        :data="data"
      ></el-transfer>
      <div class="oprate">
        <el-button type="primary" size="small" @click="handClickOprate()">{{
          $t("Customersmanage.av")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 不是我的意向客户提示 -->
    <el-dialog
      :title="$t('Customersmanage.az')"
      :visible.sync="TipsVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div class="del-box">
        <div class="delTips tc">{{ TipsText }}!</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="TipsVisible = false">{{
          $t("Customersmanage.av")
        }}</el-button>
      </span>
    </el-dialog>

    <!-- 删除重复名单提示 -->
    <el-dialog
      :title="$t('Customersmanage.az')"
      :visible.sync="delRepeat"
      width="30%"
      :before-close="handleClose"
    >
      <div class="del-box">
        <div class="delTips tc">{{ $t("Customersmanage.bl") }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="delRepeatAction()">{{
          $t("Customersmanage.av")
        }}</el-button>
        <el-button @click="delRepeat = false">{{
          $t("Customersmanage.bk")
        }}</el-button>
      </span>
    </el-dialog>

    <div id="viewerStyle" v-if="showImgMask">
      <el-image-viewer
        v-if="showViewer"
        :on-close="closeViewer"
        :url-list="showImgUrl"
      >
      </el-image-viewer>
    </div>

    <!-- 转为有效名单 -->
    <el-dialog
      title="转有效名单"
      :visible.sync="validDialogVisible"
      class="tan-binding"
      width="450px"
      :before-close="handleClose"
    >
      <div class="create" v-if="validRow">
        是否确认将<span style="color: #28abd9">{{
          validRow.client_cnname
        }}</span
        >转为有效名单？
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="changeClientToValidApi([validRow.client_id])"
          >{{ $t("Admissioncue.ax") }}</el-button
        >
        <el-button @click="validDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="批量转毛名单"
      :visible.sync="maoListVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div class="del-box">
        <div class="delTips tc">确认转毛名单？</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="maoListVisible = false">{{
          $t("Crmactivemanage.bb")
        }}</el-button>
        <el-button type="primary" @click="onBatchMaoList">{{
          $t("Crmactivemanage.bc")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 批量转为有效名单 -->
    <el-dialog
      title="批量转有效名单"
      :visible.sync="batchValidDialogVisible"
      class="tan-binding"
      width="450px"
      :before-close="handleClose"
    >
      <div class="create">
        您已选择以下<span style="color: #28abd9">{{
          MultipleClues.length
        }}</span
        >条名单？
      </div>
      <ul class="distaribution-person__list">
        <li
          v-for="(item, index) in MultipleClues"
          :key="`${index}-${item.client_id}`"
        >
          <span>{{ item.client_cnname }}</span>
          <em
            @click="handleRemoveList(index)"
            class="ml5 el-icon-circle-close"
          ></em>
        </li>
      </ul>
      <div class="create">是否确认转为有效名单？</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onBatchTurnList">{{
          $t("Admissioncue.ax")
        }}</el-button>
        <el-button @click="batchValidDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <div v-if="callPhoneVisible" class="call-phone-dialog">
      <div class="callphone-dialog flex-col flex-cc fs17 tc">
        <div class="close" @click="callPhoneVisible = false">
          <i
            class="el-icon-close"
            style="color: #fff; font-size: 26px; cursor: pointer"
          ></i>
        </div>
        <template v-if="callProcess == 1">
          <p class="title">拨打电话</p>
          <p class="tips-1">请选择号码显示方式</p>
          <p class="tips-2">
            用于展示在家长手机的来电显示方式 {{ seatsIntentionLevel }}
          </p>
          <div class="way">
            <el-radio-group v-model="callPhoneType" direction="horizontal">
              <el-radio label="1">固定电话</el-radio>
              <el-radio label="2">手机号</el-radio>
              <el-radio
                label="3"
                v-if="
                  seatsIntentionLevel &&
                  seatsIntentionLevel.includes(rowData.client_intention_level)
                "
                >400电话</el-radio
              >
            </el-radio-group>
            <p class="color-orange mt20 fs14" v-if="seatsIntentionLevel">
              400电话仅对{{
                seatsIntentionLevel
                  .split(",")
                  .map((v) => v + "星")
                  .join("、")
              }}客户开放
            </p>
          </div>
          <div class="callphone-button" @click="callClientMobileAction">
            确定拨打
          </div>
        </template>
        <template v-else-if="callProcess == 2">
          <img
            class="tips-process"
            src="@/assets/images/calling-icon.png"
            alt=""
          />
          <p class="title-1">{{ errortip }}</p>
          <div class="callphone-button" block @click="callPhoneVisible = false">
            确定
          </div>
        </template>
        <template v-else-if="callProcess == 3">
          <img
            class="tips-process"
            src="@/assets/images/calling-warn-icon.png"
            alt=""
          />
          <p class="title-1">{{ errortip }}</p>
          <div class="callphone-button" block @click="callPhoneVisible = false">
            确定
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import util from "@/utils/util";
import ElImageViewer from "../../../node_modules/element-ui/packages/image/src/image-viewer";
import PageNav from "@/components/Nav/nav.vue";
import SliderBox from "@/components/SliderBox";
import TableList from "@/components/Table/table.vue";
import userCreate from "@/components/User/create.vue";
import userSeeing from "@/components/User/seeing.vue";
import auditClass from "@/components/Class/Class.vue";
import storeCustoMersmanage from "./channelRecord.js";
export default {
  name: "CustoMersmanage-custoMersmanage",
  data() {
    return {
      rowData: {},
      errortip: "",
      callItem: null,
      callPhoneVisible: false,
      callPhoneType: "1",
      callProcess: "1",

      isDisabled: true,
      showViewer: false, // 显示查看器
      isFromGmc: false, // 是否来源于集团
      multiple: true,
      dialogVisibles: false,
      fileList: [],
      showImgMask: false,
      showImgUrl: [],
      openMenu: ["3"],
      showSliderBoxSee: false,
      showSliderBoxEdit: false,
      settingVisible: false,
      delRepeat: false, //删除重复名单
      leaningVisible: false,
      TipsVisible: false, //不是我的意向客户提示
      iscanEdit: true,
      oprateColumn: [1, 4], //编辑列
      showColumn: [],
      ClassMessage: {}, //选择的试听班级
      data: [],
      isEdit: true,
      createJG: false,
      loading: false,
      seeSliderTitle: "我的电销客户",
      TipsText: this.$t("Customersmanage.bn"), //不能跟进的提示语
      customerId: "", // 客户id
      isTrack: false, //是否点击跟进
      isRoot: false,

      clientId: "", //单个客户id
      courseBranchList: [], //课程别列表*****转正学员
      //绑定学员
      BindstudentFrom: {
        name: "",
        relation: "",
      },
      //用户基本信息
      UserInformation: [],
      ActivityOption: [],
      fu_chiefPerson: [], //副负责人
      FriendName: [], //用户绑定人员名称
      FriendRelation: [], //用户绑定关系
      followFormid: "",
      layoutVisible: false, //分配
      auditionGenre: "", //试听类型
      Auditiontime: "", //试听时间
      currentPage: 1,
      // 分页的数据
      dataNumber: 0, //数据总数
      pagenum: "1",
      pagesize: 10,
      basicinformation: [],
      dialogVisible: false,
      //筛选条件
      client_levelvalue: null,
      selectForm: {
        nohavetrack: "",
        client_level: "",
        client_tracestatus: "",
        tmk_marketer_id: "",
        markerList: "",
        range_time: "", //创建时间
        last_time: "", //最后时间
        keyword: "",
        activity: "",
        ishaveinvite: "",
        ishaveaudition: "",
        channel: "",
        order: "", //排序方式
        client_status: "", //名单状态 0 待分配 1未跟踪 2已邀约 3已试听 4已跟踪 -1 无意向
        client_track_status: "", //跟踪状态 0-待分配 ,1-待跟踪 2-跟踪中,3已转正 -1无意向
        client_answerphone: "", // 是否接通电话 0 未标记 1 已接通 -1 未接通
        channel_id: "",
        frommedia_name: "",
      },
      markerList: [],
      clientAnswerphoneList: [
        { client_answerphone: 0, client_answerphone_name: "未接通" },
        { client_answerphone: 1, client_answerphone_name: "接通有效" },
        { client_answerphone: 2, client_answerphone_name: "接通无效" },
      ],
      clientLevelNum: "", //存储意向星级数目
      intentionLevelList: [], //意向星级注释列表
      // 客户状态0待跟踪1持续跟踪2已柜询3已试听4已转正-1无意向
      clientOptionList: [
        {
          value: "0",
          label: this.$t("Customersmanage.bs"),
        },
        {
          value: "1",
          label: this.$t("Customersmanage.bt"),
        },
        {
          value: "2",
          label: this.$t("Customersmanage.bu"),
        },
        {
          value: "3",
          label: this.$t("Customersmanage.bv"),
        },
      ],
      clientOption: [
        {
          value: "",
          label: this.$t("Customersmanage.br"),
        },
        {
          value: "0",
          label: this.$t("Customersmanage.bs"),
        },
        {
          value: "1",
          label: this.$t("Customersmanage.bt"),
        },
        {
          value: "2",
          label: this.$t("Customersmanage.bu"),
        },
        {
          value: "3",
          label: this.$t("Customersmanage.bv"),
        },
        // 未柜询
        {
          value: "6",
          label: this.$t("Customersmanage.bvN1"),
        },
        // 未试听
        {
          value: "7",
          label: this.$t("Customersmanage.bvN2"),
        },
        {
          value: "8",
          label: this.$t("Customersmanage.bvN3"),
        },
        {
          value: "9",
          label: this.$t("Customersmanage.bvN4"),
        },
      ],
      // 招生渠道类型
      SchoolsourceOption: [],
      ChannelOption: [],
      OrderFieldOption: [], //获取意向客户排序字段
      chiefPerson: [], //负责人
      SchoolCourseOption: [], //意向课程
      FamilyRelation: [], //获取家庭亲属关系
      repeatList: [], //重复记录列表
      isrepeat: false,
      input: "",
      select: "",
      imageUrl: "",
      levelNum: 5, //侧边栏个数
      sliderWidth: "700px", //侧边栏宽度
      activeName: "first",
      buttonHide: false,
      filtersOption: ["电销名单跟进", "电销名单跟进记录"],
      currentIndex: 0,

      // 侧边栏 资料建档
      form: {
        chinaeseName: "",
        englishName: "",
        sex: "",
        birthday: "",
        memberNum: "",
        familyClassif: "",
        familyName: "",
        familyPhone: "",
        source: "",
        status: "",
        Introducer: "",
        chiefPerson: "",
        deputyPerson: "",
        class: "",
        classInfo: "",
        textarea: "",
      },
      //多条线索信息
      MultipleClues: [],
      Userlistedit: {
        containClass: "slider-custoMersmanage",
        sliderTitle: this.$t("Customersmanage.bw"),
      },
      // 表格数据
      columnWidth: ["200", "200", "150", "150", "250", "250", "250", "250"], //表格宽度
      tableData: [],
      optionscaozuo: {
        mutiSelect: true, // 是否支持列表项选中功能
        loading: true, //数据loading
        highlightCurrentRow: true, // 是否支持当前行高亮显示
        tableHeight: null, //表格高度
        errortip: "",
        mutiSelectTwoDisable: true, //是否disable复选框
        isShowPersonInfo: true, //是否显示个人资料保护法标识
        // specialColumns:true//特殊列
      },
      optionscaozuoTmk: {
        mutiSelect: true, // 是否支持列表项选中功能
        loading: true, //数据loading
        highlightCurrentRow: true, // 是否支持当前行高亮显示
        tableHeight: null, //表格高度
        errortip: "",
        mutiSelectTwoDisable: true, //是否disable复选框
        isShowPersonInfo: true, //是否显示个人资料保护法标识
        // specialColumns:true//特殊列
      },
      columns: [],
      allColumns: [],
      operates: {
        width: 200,
        label: this.$t("Customersmanage.bss"),
        align: "center",
        fixed: "right",
        list: [],
      }, // 列操作按钮
      tableOperate: {
        label: "",
        operate: true,
        align: "center",
        fixed: "right",
      },
      // 排序方式
      tableSort: {
        label: "",
        operate: true,
        align: "center",
        fixed: "right",
        sortOption: [],
      },
      validRow: null,
      validDialogVisible: false,
      batchValidDialogVisible: false,
      maoListVisible: false,
    };
  },
  components: {
    PageNav,
    SliderBox,
    TableList,
    userCreate,
    auditClass,
    userSeeing,
    ElImageViewer,
  },
  created() {
    this.slider = this.$store.state.Slider;
    this.token = this.$store.state.USER_TOKEN;
    this.marketer_id = this.$store.state.MARKETER_ID;
    this.school_id = this.$store.state.SCHOOL_ID;
    this.company_id = this.$store.state.COMPANY_ID;
    this.postbe_crmuserlevel = this.$Tool.getStorage("PostbeCrmlevel")
      ? this.$Tool.getStorage("PostbeCrmlevel")
      : "";
    this.re_postbe_id = this.$Tool.getStorage("re_postbe_id")
      ? this.$Tool.getStorage("re_postbe_id")
      : "";
    this.language_type = this.$Tool.getStorage("language")
      ? this.$Tool.getStorage("language")
      : "";
    // 权限判断
    this.postbe_crmlevel = this.$store.state.POSTBE_CRMLEVEL;
    if (this.$route.query.client_tracestatus) {
      this.selectForm.client_tracestatus = this.$route.query.client_tracestatus;
    }
    this.selectForm.nohavetrack = this.$route.query.nohavetrack || "";

    // this.addClass(0);
    this.getgetClientData(this.pagenum);
    this.changeOpera();
    this.getSource(); // 获取招生渠道类型
    this.getOrderFieldApi(); //获取意向客户排序字段
    this.getMarketer(); // 获取招生的负责人
    this.getActivityData(); // 获取活动名称
    this.getIntentCourseData(); // 获取意向课程
    this.getFamilyRelationData(); // 获取家庭亲属关系
    this.getTmkMarketerApi();
    this.getChannelData();
    this.getIntentionLevelList();
  },
  watch: {
    callPhoneVisible(n) {
      if (!n) {
        this.errortip = "";
        this.callItem = null;
        this.callPhoneType = "1";
        this.callProcess = "1";
      }
    },
  },
  computed: {
    seatsIntentionLevel() {
      return this.$store.state.seatsIntentionLevel;
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs["auto_height_table"]) {
        this.optionscaozuo.tableHeight = this.$Common.getTableHeight(
          this.$refs.auto_height_table.getBoundingClientRect().top + 95
        );
      }
    });
    util.$on("test", (v) => {
      this.handleClick(v);
    });
  },
  methods: {
    emitCallPhone(val) {
      this.callItem = val;
      this.rowData = { ...val };
      this.callPhoneVisible = true;
    },
    callClientMobileAction() {
      storeCustoMersmanage
        .callClientMobileAction({
          client_id: this.callItem.client_id,
          numbertype: this.callPhoneType,
        })
        .then((res) => {
          const { code, msg } = res.data;
          this.errortip = msg;
          if (code === 200) {
            this.callProcess = 2;
            ``;
          } else {
            this.callProcess = 3;
          }
        });
    },

    addClass(index) {
      this.currentIndex = index;
      this.currentPage = 1;
      this.selectForm.client_level = "";
      this.selectForm.client_tracestatus = "";
      this.selectForm.tmk_marketer_id = "";
      this.selectForm.range_time = ""; //创建时间
      this.selectForm.last_time = ""; //最后时间
      this.selectForm.keyword = "";
      this.selectForm.activity = "";
      this.selectForm.ishaveinvite = "";
      this.selectForm.ishaveaudition = "";
      this.selectForm.channel = "";
      this.selectForm.order = ""; //排序方式
      this.selectForm.client_status = "";
      this.selectForm.client_track_status = "";
      this.selectForm.client_answerphone = "";
      this.selectForm.channel_id = "";
      this.selectForm.frommedia_name = "";
      this.changeOpera();
      this.getgetClientData(this.pagenum);
    },
    changeOpera() {
      if (this.currentIndex == 0) {
        this.operates.list = [
          {
            id: "1",
            label: this.$t("Customersmanage.by"),
            type: "text",
            show: true,
            plain: true,
            Customfloow: true,
            disabled: false,
            method: (index, row) => {
              this.handleClick(row);
            },
          },
          {
            id: "2",
            label: "转有效名单",
            type: "text",
            show: true,
            plain: true,
            Customfloow: true,
            disabled: false,
            method: (index, row) => {
              this.validRow = row;
              this.validDialogVisible = true;
            },
          },
        ];
        this.optionscaozuo.mutiSelect = true;
      } else {
        this.operates.list = [];
        this.optionscaozuo.mutiSelect = false;
      }
    },
    updateList() {
      this.getgetClientData(this.pagenum);
    },
    handleSelectChange(val) {
      console.warn(val);
      this.updateClientAnswerPhoneAction(val);
    },
    // 跟新电话接通状态
    updateClientAnswerPhoneAction(val) {
      storeCustoMersmanage
        .updateClientAnswerPhoneAction({
          client_id: this.customerId, // 客户id
          client_answerphone: val, // 接通状态
        })
        .then((res) => {
          (() => {})(res);
          const { code, msg } = res.data;
          if (code === 200) {
            this.$message({
              type: "success",
              message: msg,
            });
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
        });
    },
    handleRemoveList(i) {
      this.MultipleClues.splice(i, 1);
    },
    onTurnAllList() {
      (() => {})(this.MultipleClues);
      this.batchValidDialogVisible = true;
    },
    onBatchMaoList() {
      let arrMultiple = [];
      this.MultipleClues.forEach((item) => {
        arrMultiple.push({ client_id: item.client_id });
      });
      if (arrMultiple.length === 0) {
        this.$message({
          message: "请至少选择一条名单",
          type: "error",
        });
        return;
      }
      storeCustoMersmanage
        .changeLossClientTmkApi({
          moduletype: 1,
          clients_json: JSON.stringify(arrMultiple),
        })
        .then((res) => {
          const { code, msg } = res.data;
          if (code === 200) {
            this.$message.success(msg);
            this.maoListVisible = false;
            this.getgetClientData(this.pagenum);
          } else {
            this.$message.error(msg);
          }
        });
    },
    onBatchTurnList() {
      let list = [];
      this.MultipleClues.forEach((v) => {
        list.push(v.client_id);
      });
      this.changeClientToValidApi(list);
    },
    changeClientToValidApi(list) {
      if (list.length === 0) {
        this.$message({
          message: "请至少选择一条名单",
          type: "error",
        });
        return;
      }
      let clients_json = [];
      list.forEach((v) => {
        clients_json.push({ client_id: v });
      });
      storeCustoMersmanage
        .changeClientToValidApi({
          clients_json: JSON.stringify(clients_json),
          isgrossmenu: "1",
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.validDialogVisible = false;
            this.batchValidDialogVisible = false;
            this.getgetClientData(this.pagenum);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    // 关闭查看器
    closeViewer() {
      this.showViewer = false;
    },

    handleRemove(file, fileList) {
      (() => {})(file, fileList);
    },
    // 公共->意向星级注释列表->zjc
    getIntentionLevelList() {
      this.$http.getIntentionLevelList({}).then((res) => {
        let list = res.data.data.list;
        let arr = [];
        list.forEach((e) => {
          arr.push(e.intentlevel_remark);
        });
        this.intentionLevelList = arr;
      });
    },
    emitShowImg(v) {
      this.showImgUrl = v.split(",");
      this.showImgMask = true;
      this.showViewer = true;
    },
    // 招生有效名单表格数据
    getgetClientData() {
      let params = {
        marketer_id: this.marketer_id,
        token: this.token,
        school_id: this.school_id,
        company_id: this.company_id,
        is_count: "1", //是否需要总数，可以不传
        p: this.currentPage,
        num: this.pagesize,
        postbe_crmuserlevel: this.postbe_crmlevel,
        // 非必须传
        frommedia_name: this.selectForm.frommedia_name,
        channel_id: this.selectForm.channel_id,
        tmk_marketer_id: this.selectForm.tmk_marketer_id,
        track_intention_level: this.clientLevelNum,
        client_tracestatus: this.selectForm.client_tracestatus,
        nohavetrack: this.selectForm.nohavetrack,
        keyword: this.selectForm.keyword,
        activity_id: this.selectForm.activity,
        ishaveinvite: this.selectForm.ishaveinvite,
        ishaveaudition: this.selectForm.ishaveaudition,
        order: this.selectForm.order,
        create_starttime: this.selectForm.range_time
          ? this.selectForm.range_time[0]
          : "",
        create_endtime: this.selectForm.range_time
          ? this.selectForm.range_time[1]
          : "",
        track_createtime: this.selectForm.last_time
          ? this.selectForm.last_time[0]
          : "",
        track_endtime: this.selectForm.last_time
          ? this.selectForm.last_time[1]
          : "",
        client_answerphone: this.selectForm.client_answerphone,
        isgross: "1",
      };
      let axiosMethod = (res) => {
        this.tableData = res.data.data.list;
        this.dataNumber = parseInt(res.data.data.all_num);
        var Columns = res.data.data.field;
        this.allColumns = res.data.data.field;
        this.$Tool.setStorage("allColumns", this.allColumns);
        this.showColumn = JSON.parse(localStorage.getItem("showColumns"));
        var fieldColumns = res.data.data.field;
        if (JSON.parse(localStorage.getItem("showColumns"))) {
          Columns = this.showColumn;
          fieldColumns = this.showColumn;
        }
        this.columns = this.$Common.handleTable(
          Columns,
          this.columnWidth,
          true,
          0
        );
        this.columns.forEach((v) => {
          if (v.prop == "client_tag") {
            this.$set(v, "istag", true);
            this.$set(v, "width", "220px");
          }
        });
        this.optionscaozuo.loading = false;
        this.optionscaozuoTmk.loading = false;
        var arr = [];
        var arr2 = [];
        fieldColumns.forEach((item, index) => {
          arr.push({
            key: index,
            label: item.fieldstring,
            disabled: item.custom === "0",
          });
          if (item.show == "0") {
            arr2.push(index);
          }
        });
        this.data = arr;
        this.oprateColumn = arr2;
        if (res.data.code !== 200) {
          this.optionscaozuo.errortip = res.data.msg;
          this.optionscaozuoTmk.errortip = res.data.msg;
        }
      };
      if (this.currentIndex === 0) {
        storeCustoMersmanage.getOneTmkClient(params).then((res) => {
          axiosMethod(res);
        });
      } else {
        storeCustoMersmanage.getOneTmkClientRecord(params).then((res) => {
          axiosMethod(res);
        });
      }
    },
    // 编辑列
    Changeoprate() {},
    //获取意向客户排序字段
    getOrderFieldApi() {
      storeCustoMersmanage
        .getOrderFieldApi({
          company_id: this.company_id,
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
        })
        .then((res) => {
          var d = res.data.data || res.data;
          var raw =
            res.data.list ||
            (res.data.result && res.data.result.list) ||
            (d && d.list) ||
            (d && d.result && d.result.list) ||
            (Array.isArray(d) ? d : []);
          this.OrderFieldOption = Array.isArray(raw) ? raw.slice() : [];
          this.OrderFieldOption.unshift({
            field: "",
            name: this.$t("Customersmanage.br"),
          });
          this.tableSort.sortOption = this.OrderFieldOption;
        });
    },
    //获取活动名称
    getActivityData() {
      storeCustoMersmanage
        .getActivity({
          company_id: this.company_id,
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
        })
        .then((res) => {
          this.ActivityOption = res.data.data.list;
        });
    },
    //获取招生渠道类型
    getSource() {
      this.$http
        .getSource({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          this.SchoolsourceOption = res.data.data.list;
        });
    },
    //获取招生渠道明细
    getChannelData() {
      this.$http
        .getChannel({
          company_id: this.company_id,
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          channel_medianame: this.selectForm.frommedia_name,
        })
        .then((res) => {
          this.ChannelOption = res.data.data.list;
        });
    },
    getTmkMarketerApi() {
      storeCustoMersmanage.getTmkMarketerApi({}).then((res) => {
        this.markerList = res.data.data.list;
      });
    },
    // 招生渠道类型筛选
    frommediaSearch() {
      this.selectForm.channel_id = "";
      this.getChannelData(); // 获取渠道明细
      this.handleSelect();
    },
    // 获取招生的负责人
    getMarketer() {
      storeCustoMersmanage
        .getMarketer({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          (() => {})(res.data.data.list);
          this.chiefPerson = res.data.data.list;
        });
    },
    //获取意向课程
    getIntentCourseData() {
      storeCustoMersmanage
        .getIntentCourse({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          (() => {})(res.data);
          this.SchoolCourseOption = res.data.data.list;
        });
    },
    // 获取家庭亲属关系
    getFamilyRelationData() {
      storeCustoMersmanage
        .getFamilyRelation({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          (() => {})(res.data);
          this.FamilyRelation = res.data.data.list;
        });
    },
    // 选择意向星级查询
    handleSelectLevel() {
      if (this.clientLevelNum == this.client_levelvalue) {
        this.client_levelvalue = null;
        this.clientLevelNum = "";
      } else {
        this.clientLevelNum = this.client_levelvalue;
      }
      this.currentPage = 1;
      this.getgetClientData(this.pagenum);
    },
    // 选择查询
    handleSelect() {
      this.currentPage = 1;
      this.getgetClientData(this.pagenum);
    },
    // 输入关键词查询
    handleSelectKeyword() {
      this.currentPage = 1;
      this.getgetClientData(this.pagenum);
    },
    // 编辑意向客户
    editClientData(data) {
      storeCustoMersmanage.editClient(data).then((res) => {
        (() => {})(res.data);
        if (res.data.code === 200) {
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.getgetClientData(this.pagenum, "");
          this.showSliderBoxEdit = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    //编辑时删除家庭信息
    deleteFamily(v) {
      if (v.family_id) {
        storeCustoMersmanage
          .delFamilyRelation({
            marketer_id: this.marketer_id,
            token: this.token,
            company_id: this.company_id,
            school_id: this.school_id,
            family_id: v.family_id,
          })
          .then((res) => {
            if (res.data.code === 200) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.getgetClientData(this.pagenum, "");
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
      }
    },
    //编辑时删除课程信息
    deleteCourse(v) {
      if (v.intention_id) {
        storeCustoMersmanage
          .delIntentionSource({
            marketer_id: this.marketer_id,
            token: this.token,
            company_id: this.company_id,
            school_id: this.school_id,
            intention_id: v.intention_id,
          })
          .then((res) => {
            if (res.data.code === 200) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.getgetClientData(this.pagenum, "");
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
      }
    },
    // 获取单个客户的基本信息
    getclientOneData(id) {
      storeCustoMersmanage
        .getclientOne({
          marketer_id: this.marketer_id,
          token: this.token,
          client_id: id,
        })
        .then((res) => {
          (() => {})(res.data.data.list);
          this.UserInformation = res.data.data.list;
        });
    },
    // 新增时-检测重名
    checkIntentionClientData(val) {
      var id;
      if (this.isEdit) {
        id = this.customerId;
      } else {
        id = "";
      }
      storeCustoMersmanage
        .checkIntentionClient({
          token: this.token,
          marketer_id: this.marketer_id,
          client_cnname: val.client_cnname,
          client_mobile: val.client_mobile,
          company_id: this.company_id,
          school_id: this.school_id,
          client_id: id,
        })
        .then((res) => {
          (() => {})(res.data);
          if (res.data.code === 200) {
            this.isrepeat = false;
          } else {
            if (res.data.data.list != undefined) {
              this.isrepeat = true;
              this.repeatList = res.data.data.list;
            }
          }
        });
    },
    // 获取单个客户的绑定关系
    getFriendRelationData(id) {
      storeCustoMersmanage
        .getFriendRelation({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          client_id: id,
        })
        .then((res) => {
          (() => {})(res.data.data.list);
          this.FriendRelation = res.data.data.list;
        });
    },
    // 绑定学员->获取人员名称
    getClientNameData(keyword) {
      storeCustoMersmanage
        .getClientName({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          client_cnname: keyword,
        })
        .then((res) => {
          this.FriendName = res.data.data.list;
          this.loading = false;
        });
    },
    // 远程搜索绑定学员的名称
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        this.getClientNameData(query);
      } else {
        this.FriendName = [];
      }
    },
    //绑定学员提交
    onBindSubmit() {
      storeCustoMersmanage
        .bindingClient({
          token: this.token,
          marketer_id: this.marketer_id,
          from_client_id: this.from_client_id,
          to_client_id: this.BindstudentFrom.name,
          binding_friend_relation: this.BindstudentFrom.relation,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getgetClientData(this.pagenum, "");
            this.createJG = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    // 绑定学员显示
    studentBinding() {
      this.BindstudentFrom = {
        name: "",
        relation: "",
      }; //数据初始化
      this.getFriendRelationData();
      this.createJG = true;
    },
    //查看点击编辑
    Clickedit() {
      this.getIntentCourseData();
      this.showSliderBoxSee = false;
      this.showSliderBoxEdit = true;
    },
    //点击查看
    handleColumnChange(k, v) {
      this.isRoot = false;
      this.activeName = "first";
      this.isTrack = false;
      this.iscanEdit = true;
      this.from_client_id = v.client_id;
      this.customerId = v.client_id; //存储客户ID
      this.getclientOneData(v.client_id);

      this.showSliderBoxSee = true;
    },
    //跟班试听
    leaning() {
      this.leaningVisible = true;
    },
    // 试听类型
    ClickAudition(v) {
      this.auditionGenre = v;
    },
    // 试听时间
    ClickAuditiontime(v) {
      (() => {})(v, 121213);
      this.Auditiontime = v;
    },
    handClickcompare(v) {
      (() => {})(v);
      this.ClassMessage = v;
      this.leaningVisible = false;
    },
    handClickcancel() {
      this.leaningVisible = false;
    },
    handleCloseLean() {
      this.$confirm(this.$t("Customersmanage.cb"))
        .then(() => {
          this.leaningVisible = false;
        })
        .catch((_) => {
          (() => {})(_);
        });
    },
    // Crm->删除重复名单
    delRepeatAction() {
      this.$http
        .delRepeatAction({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id,
          client_id: this.clientId,
          postbe_crmlevel: this.postbe_crmlevel,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getgetClientData(this.pagenum);
            this.delRepeat = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },

    // 我要跟进
    handleClick(v) {
      // 判断是否为我的意向客户*** 0 时跟进显示灰色
      if (v.client_forbid == "0") {
        this.TipsVisible = true;
        (() => {})(v);
        if (v.client_tracestatus == "4") {
          this.TipsText = this.$t("Customersmanage.cc");
        } else {
          this.TipsText = this.$t("Customersmanage.cd");
        }
      } else {
        this.isRoot = true;
        this.iscanEdit = false;
        this.isTrack = true; //是否点击我要跟进
        this.from_client_id = v.client_id;
        this.followFormid = v.client_id; //跟进
        this.customerId = v.client_id; //存储客户ID
        this.getclientOneData(v.client_id);
        this.showSliderBoxSee = true;
      }
    },
    //跟进提交
    onFllowSubmit(v) {
      v.isgross = "1";
      // v.isgross = this.postbe_crmuserlevel === "2" ? "1" : "0";
      v.token = this.token;
      v.marketer_id = this.marketer_id;
      v.school_id = this.school_id;
      v.company_id = this.company_id;
      if (this.followFormid != "") {
        v.client_id = this.followFormid;
      }
      storeCustoMersmanage.settingtrackClient(v).then((res) => {
        (() => {})(res.data);
        if (res.data.code === 200) {
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.getgetClientData(this.pagenum, "");
          this.showSliderBoxSee = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    // 绑定学员点击跟进
    ClickFloow(v) {
      this.customerId = v.client_id;
    },
    // 显示 列切换
    toggleEditableColumn() {
      (() => {})("显示 列切换");
      this.settingVisible = !this.settingVisible;
    },
    // 点击排序方式***功能菜单
    handleCommandSort(command) {
      (() => {})(command);
      this.selectForm.order = command;
      this.currentPage = 1;
      this.getgetClientData(this.pagenum);
    },
    // 自定义编辑列
    handClickOprate() {
      let allnum = JSON.parse(localStorage.getItem("allColumns"));
      allnum.forEach((item, index) => {
        allnum[parseInt(index)].show = "1";
      });
      this.oprateColumn.forEach((item) => {
        allnum[parseInt(item)].show = "0";
      });
      this.showColumns = allnum;
      this.$Tool.setStorage("showColumns", this.showColumns);
      this.settingVisible = false;
      this.getgetClientData(this.pagenum);
    },
    hideSliderBoxEdit() {
      this.showSliderBoxEdit = false;
    },
    hideSliderSeeBox() {
      this.showSliderBoxSee = false;
    },
    //编辑招生意向客户
    oneditSubmit(value) {
      let newVal = value;
      newVal["marketer_id"] = this.marketer_id;
      newVal["token"] = this.token;
      newVal["school_id"] = this.school_id;
      newVal["company_id"] = this.company_id;
      this.$delete(newVal, "client_tag");
      this.$delete(newVal, "client_tags");
      var isnull =
        value.client_cnname != "" &&
        value.client_sex != "" &&
        value.client_mobile != "";
      if (isnull) {
        this.editClientData(newVal);
      } else {
        this.$message({
          message: this.$t("Customersmanage.cg"),
          type: "error",
        });
      }
    },
    // 我要跟踪
    wantToTrack(v) {
      this.getclientOneData(v.client_id);
      this.isRoot = true;
      this.iscanEdit = false;
      this.isTrack = true; //是否点击我要跟进
      this.from_client_id = v.client_id;
      this.followFormid = v.client_id; //跟进
      this.customerId = v.client_id; //存储客户ID
      this.getclientOneData(v.client_id);
      this.showSliderBoxSee = true;
    },
    handleSliderClick(v) {
      if (v == "first") {
        this.iscanEdit = true;
        this.getclientOneData(this.customerId);
      } else {
        if (v == "fourth") {
          this.isRoot = true;
          this.iscanEdit = false;
        } else {
          this.iscanEdit = false;
        }
      }
    },
    handleClose(done) {
      this.$confirm(this.$t("Customersmanage.cb"))
        .then((_) => {
          (() => {})(_);
          done();
        })
        .catch((_) => {
          (() => {})(_);
        });
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getgetClientData(this.pagenum);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getgetClientData(val);
    },
    handleSelectionChange(val) {
      this.MultipleClues = val;
      this.isFromGmc = val.some(
        (v) => v.isgmcIndschoolenter == 1 && v.isgmcschoolenter != 1
      );
      if (val != "") {
        let timer = setTimeout(() => {
          this.buttonHide = true;
          clearTimeout(timer);
        }, 10);
      } else {
        this.buttonHide = false;
      }
    },
  },
};
</script>
<style lang="less">
@import url("../../assets/less/manage.less");
@import url("channelRecord.less");
.show-img__mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000000;
  img {
    max-width: 100%;
    max-height: 100%;
  }
}
.distaribution-person__list {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
  li {
    margin: 15px 10px 0 0;
    padding: 3px 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(222, 222, 222, 1);
    border-radius: 3px;
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 20px;
    }
    em {
      color: rgb(244, 67, 67);
      cursor: pointer;
    }
  }
}
.channelRecord {
  height: 100vh;
  font-size: 20px;
  .apply-channel__desc {
    display: flex;
    margin: 0 -20px;
    line-height: 35px;
    align-items: center;
    justify-content: center;
    color: rgba(32, 168, 216, 1);
    background-color: rgba(32, 168, 216, 0.14);
  }
  .content-nav--head {
    padding: 0px 20px 0px 0px;
    .filter-condition li {
      padding: 0px 20px;
    }
  }
  .apply-channel__notice {
    color: red;
  }
  .apply-user-pop {
    display: flex;
    padding: 20px;
    align-items: center;
    .user-info__img {
      width: 120px;
      padding-right: 13px;
      display: flex;
      justify-content: flex-end;
      img {
        display: block;
        width: 53px;
        height: 53px;
        border-radius: 50%;
      }
    }
    .user-info__name {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 30px;
      display: flex;
      align-items: center;
      .user-tips {
        margin-left: 20px;
        padding: 0 8px;
        font-size: 14px;
        line-height: 30px;
        font-style: normal;
        color: rgba(32, 168, 216, 1);
        border-radius: 5px;
        background-color: rgba(32, 168, 216, 0.05);
      }
    }
  }
  .choose-user-row {
    display: flex;
    padding: 0 20px;
    .tit {
      width: 100px;
    }

    .user-content {
      flex: 1;
      padding-top: 2px;
      margin-bottom: 0px;
      display: flex;
      flex-wrap: wrap;
    }

    .user-content-item {
      margin: 0 30px 15px 0;
      position: relative;
      .el-icon-circle-close {
        top: -5px;
        right: -15px;
        position: absolute;
        color: red;
        cursor: pointer;
        &:hover {
          color: #20a8d8;
        }
      }
    }
  }
}

#uploadSty {
  .el-dialog__wrapper {
    overflow: hidden !important;
  }
  .el-dialog {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100% !important;
    height: 100% !important;
    margin: 0 !important;
  }
  .el-dialog__header {
    padding: 0 !important;
    height: 50px;
  }
  .el-dialog__body {
    border: none !important;
  }
}
// .v-modal {
//   z-index: -99 !important;
// }

#dialogSty {
  .el-dialog__header {
    padding: 0 !important;
    height: 50px;
  }
  .el-dialog__body {
    border: none !important;
  }
}

#viewerStyle {
  .el-image-viewer__wrapper {
    position: fixed;
    background: rgba(0, 0, 0, 0.3);
    top: 0px;
    left: 0px;
    max-height: 100%;
    max-width: 100%;
    width: 100%;
    height: 100%;
  }
  .el-image-viewer__btn {
    color: #777;
  }
  .el-image-viewer__close {
    position: absolute;
    right: 0;
    z-index: 20000000;
  }
  .el-image-viewer__prev {
    position: absolute;
    top: 50%;
    left: 5%;
    z-index: 20000000;
  }
  .el-image-viewer__next {
    position: absolute;
    top: 50%;
    right: 5%;
    z-index: 20000000;
  }
  .el-icon-arrow-left {
    font-size: 80px;
  }
  .el-icon-arrow-right {
    font-size: 80px;
  }
  .el-icon-circle-close {
    font-size: 40px;
  }
  .el-icon-zoom-out {
    font-size: 40px;
  }
  .el-icon-zoom-in {
    font-size: 40px;
  }
  .el-icon-full-screen {
    font-size: 40px;
  }
  .el-icon-refresh-left {
    font-size: 40px;
  }
  .el-icon-refresh-right {
    font-size: 40px;
  }
  .el-icon-arrow-left:hover,
  .el-icon-arrow-right:hover,
  .el-icon-circle-close:hover,
  .el-icon-zoom-out:hover,
  .el-icon-zoom-in:hover,
  .el-icon-full-screen:hover,
  .el-icon-refresh-left:hover,
  .el-icon-refresh-right:hover {
    cursor: pointer;
  }
  .el-image-viewer__actions__inner {
    position: absolute;
    left: 50%;
    bottom: 5%;
    z-index: 20000000;
    background-color: #888;
  }
  .el-image-viewer__canvas img {
    margin: auto !important;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
}
</style>
